import { gql } from '@apollo/client';
import type { BookmarkFolder } from 'types/Folder';
import { BOOKMARK_FOLDER_FRAGMENT } from './AdminBookmarkFolderFragments';

export const GET_BOOKMARK_FOLDERS_QUERY = gql`
  query GetBookmarkFolders($adminFoldersByFolderTypeInput: AdminFoldersByFolderTypeInput!) {
    adminFoldersByFolderType(adminFoldersByFolderTypeInput: $adminFoldersByFolderTypeInput) {
      __typename
      ... on AdminFoldersByFolderTypeErrorOutput {
        errorReason
      }
      ... on AdminGetFoldersByFolderTypeOutput {
        folders {
          ...BookmarkFolder
        }
      }
    }
  }
  ${BOOKMARK_FOLDER_FRAGMENT}
`;

export enum GetBookmarkFoldersError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED', // TODO : missing in backend
  WRONG_FOLDER_TYPE = 'WRONG_FOLDER_TYPE', // TODO : missing in backend
}

export type GetBookmarkFoldersOutput = {
  adminFoldersByFolderType: {
    __typename: string;
    errorReason: GetBookmarkFoldersError;
    folders: BookmarkFolder[];
  };
};